import { render } from "./Gallery.vue?vue&type=template&id=6f803d5e&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=6f803d5e&scoped=true&lang=css"

import exportComponent from "D:\\Front-end\\Beetronix\\alradwan-frontend\\vue-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f803d5e"]])

export default __exports__